import { CircularProgress } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from "@mui/material";
import { t } from "i18next";
import { useContext, useState } from "react";
import CustomModal from "../Components/CustomModal/CustomModal";
import EvaluationQuestionWrapper from "../Components/Questions/EvaluationQuestionWrapper";
import { configUrl } from "../config";
import { LoginContext } from "../contexts/LoginContext";



const getCellColor = (stats) => {
    if (!stats) return "white";

    if (stats.Total === stats.Correct) return "#a5f4a5"; // all correct
    if (stats.Total === stats.Incorrect) return "#f29f9b"; // all incorrect
    if (stats.Total === stats.Unattempted) return "white"; // all unattempted
    return "#fcd199"; // partial (yellow/orange)
};
const getTopicBackground = (tests, totalTestsCount) => {
    if (!tests) return "white";

    let appearedTests = 0;
    let fullyCorrectTests = 0;
    let fullyIncorrectTests = 0;
    let fullyUnattemptedTests = 0;
    let mixedTests = 0;

    Object.values(tests).forEach((stats) => {
        if (!stats || typeof stats !== "object" || (stats.Total || 0) === 0) return;

        appearedTests++;

        if (stats.Total === stats.Correct) {
            fullyCorrectTests++;
        } else if (stats.Total === stats.Incorrect) {
            fullyIncorrectTests++;
        } else if (stats.Total === stats.Unattempted) {
            fullyUnattemptedTests++;
        } else {
            mixedTests++;
        }
    });

    // No questions at all
    if (appearedTests === 0) return "white";

    //  All appeared tests are unattempted
    if (appearedTests === fullyUnattemptedTests) {
        return "white"; // unattempted
    }

    //  Case 1: If 3 tests are fully correct, and the rest have no questions
    if (fullyCorrectTests >= configUrl.pulseMatrixPassCriteria && appearedTests === fullyCorrectTests) {
        return "#62ff62"; // green
    }

    //  Case 2: If all tests appeared and all are fully correct
    if (appearedTests === totalTestsCount && fullyCorrectTests === totalTestsCount) {
        return "#62ff62"; // green
    }

    //  Case 3: If all appeared tests are fully incorrect
    if (appearedTests > 0 && appearedTests === fullyIncorrectTests) {
        return "#ff6961"; // red
    }

    //  Case 4: If all tests appeared but not all correct/incorrect
    if (appearedTests === totalTestsCount) {
        return "#ffc57a"; // orange
    }

    //  Case 5: Fallback → Orange (partially correct/mixed)
    return "#ffc57a";
};





// const getTopicBackground = (tests) => {
//     if (!tests) return "white";

//     let totalQ = 0, correctQ = 0, incorrectQ = 0, unattemptedQ = 0;

//     Object.values(tests).forEach((stats) => {
//         if (!stats || typeof stats !== "object") return;
//         totalQ += stats.Total || 0;
//         correctQ += stats.Correct || 0;
//         incorrectQ += stats.Incorrect || 0;
//         unattemptedQ += stats.Unattempted || 0;
//     });

//     if (totalQ === 0) return "white"; // safeguard

//     if (totalQ === correctQ) return "#62ff62";   // all correct
//     if (totalQ === incorrectQ) return "#ff6961"; // all incorrect
//     if (totalQ === unattemptedQ) return "white"; // all unattempted

//     return "#ffc57a"; // mixed (yellow/orange)
// };


const TopicPulseTable = ({ matrixTableData, isLoading }) => {
    const { UserId } = useContext(LoginContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [evaluationModel, setEvaluationModel] = useState();
    const [topicFilter, setTopicFilter] = useState("orange");
    const [isTggleOpen, setIsToggleOpen] = useState("all");

    const handleToggle = (event, newSubscription) => {
        if (newSubscription !== null) {
            setTopicFilter(newSubscription)  // === "completed");
        }
    };
    const toggleGroupStyles = {
        display: 'inline-flex',
        float: 'right',
        borderRadius: '87px',
        borderColor: "black",
        padding: '5px',
        // marginTop: '2%',
        // marginRight: '9px',
        marginBottom: '10px',
        backgroundColor: '#f2e7e7',
        boxShadow: 'inset 0 1px 2px 0 rgba(0, 0, 0, 0.1)'
    };

    const allTests = Array.from(
        new Set(matrixTableData && matrixTableData?.flatMap((topic) => Object.keys(topic.Tests)))
    );
    const allTestsInfo = Array.from(
        new Map(
            matrixTableData?.flatMap(topic =>
                Object.values(topic.Tests).map(test => [
                    test.testAttemptedOn, // use date as unique key
                    { testId: test.TestId, testName: test.testName, testAttemptedOn: test.testAttemptedOn }
                ])
            ) ?? []
        ).values()
    ).sort((a, b) => new Date(b.testAttemptedOn) - new Date(a.testAttemptedOn));

    console.log(allTests, '-allTests')
    console.log(matrixTableData, '-matrixTData')
    function toIST(date) {
        // convert UTC → IST (+5:30)
        const istOffset = 5.5 * 60 * 60 * 1000;
        return new Date(date.getTime() + istOffset);
    }

    function formatDate(isoString) {
        // const date = new Date(isoString);
        const dateUTC = new Date(isoString);
        const dateIST = toIST(dateUTC);
        if (isMobile) {
            return dateIST.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
            });
        } else {
            return dateIST.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
            });
        }
    }
    function formatTime(isoString) {
        // const date = new Date(isoString);
        const dateUTC = new Date(isoString);
        const dateIST = toIST(dateUTC);

        return dateIST.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
    }
    const hideEvaluationModel = (event, reason) => {
        if (reason) console.log("reason", reason);
        setEvaluationModel(null);
    };
    const showEvaluationModel = (id, testName) => {
        console.log('Click2')
        setEvaluationModel(
            <CustomModal
                modal={true}
                setModal={hideEvaluationModel}
                content={
                    <EvaluationQuestionWrapper
                        testId={id}
                        userId={UserId ?? null}
                        isCourse={false}
                    />
                }
                showOk={false}
                showCancel={false}
                onCancelClick={hideEvaluationModel}
                title={`${testName} ${t('evaluation')}`}
                maxWidth="lg"
                hideTitle={true}
                fullScreen={true}
                fullWidth={false}
            />
        );
    };
    return (
        <div>
            {/* <div style={{
                marginTop: "2%",
                display: "flex",
                gap: "1rem",
                alignItems: "center",
                fontSize: '1.1vw',
                fontFamily: 'Poppins'
            }}>

                <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <input
                        type="radio"
                        name="topicFilter"
                        value="all"
                        checked={topicFilter === "all"}
                        onChange={(e) => setTopicFilter(e.target.value)}
                    />
                    <span>All</span>
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <input
                        type="radio"
                        name="topicFilter"
                        value="green"
                        checked={topicFilter === "green"}
                        onChange={(e) => setTopicFilter(e.target.value)}
                    />
                    <span style={{
                        color: "green",
                        // padding: "2px 8px",
                        // borderRadius: "4px"
                    }}>Correct</span>
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <input
                        type="radio"
                        name="topicFilter"
                        value="red"
                        checked={topicFilter === "red"}
                        onChange={(e) => setTopicFilter(e.target.value)}
                    />
                    <span style={{
                        // background: "#ff6961",
                        // padding: "2px 8px",
                        // borderRadius: "4px",
                        color: "#ff6961"
                    }}
                    >Incorrect</span>
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <input
                        type="radio"
                        name="topicFilter"
                        value="orange"
                        checked={topicFilter === "orange"}
                        onChange={(e) => setTopicFilter(e.target.value)}
                    />
                    <span style={{
                        color: "#dea807",
                        // padding: "2px 8px",
                        // borderRadius: "4px"
                    }}
                    >Orange</span>
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <input
                        type="radio"
                        name="topicFilter"
                        value="white"
                        checked={topicFilter === "white"}
                        onChange={(e) => setTopicFilter(e.target.value)}
                    />
                    <span style={{
                        color: "gray",
                        // padding: "2px 8px",
                        // borderRadius: "4px",
                        // border: "1px solid #ccc"
                    }}
                    >Unattempted</span>
                </label>
            </div>*/}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2%' }}>
                <div>
                    {
                        topicFilter === 'green' ?
                            <h4>Something that is right or accurate.</h4> :
                            topicFilter === 'red' ?
                                <h4>Something that is wrong or inaccurate.</h4> :
                                topicFilter === 'orange' ?
                                    <h4>Something you can improve here- Opportunity area.</h4> :
                                    topicFilter === 'white' ?
                                        <h4>Something you haven’t tried or attempted yet.</h4> : ''


                    }
                </div>
                <div>
                    <ToggleButtonGroup
                        value={topicFilter}
                        exclusive
                        onChange={handleToggle}
                        aria-label="Subscription Toggle"
                        style={toggleGroupStyles}
                    >
                        {/* <ToggleButton
                    value="all"
                    disabled={isLoading == true}
                    aria-label="all"
                    style={
                        // toggleButtonStyles(isTggleOpen)
                        {
                            fontSize: '11px',
                            fontFamily: 'Poppins',
                            borderRadius: topicFilter == 'all' ? '87px' : '0',
                            padding: '5px 7px',
                            textTransform: 'capitalize',
                            border: 'none',
                            backgroundColor: topicFilter == 'all' ? "#fff" : "transparent",
                            color: topicFilter == 'all' ? "#012248" : "#a0a0a0",
                            cursor: 'pointer',
                            boxShadow: topicFilter == 'all' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                            transition: 'background-color 0.3s ease, color 0.3s ease',
                            '&:hover': {
                                backgroundColor: theme.palette.heading.main,
                                color: theme.palette.drawerBackground.main,
                                transform: 'scale(1.05)',
                            },
                        }
                    } >
                    {t("All")}
                </ToggleButton> */}
                        <ToggleButton
                            value="green"
                            disabled={isLoading === true}
                            aria-label="green"
                            style={
                                // toggleButtonStyles(isTggleOpen)
                                {
                                    fontSize: '11px',
                                    fontFamily: 'Poppins',
                                    borderRadius: topicFilter === 'green' ? '87px' : '0',
                                    padding: '5px 7px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: topicFilter === 'green' ? "#fff" : "transparent",    //#62ff62
                                    color: topicFilter === 'green' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: topicFilter === 'green' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }
                            } >
                            {t("Green")}
                        </ToggleButton>
                        <ToggleButton
                            value="red"
                            disabled={isLoading === true}
                            aria-label="red"
                            style={
                                // toggleButtonStyles(isTggleOpen)
                                {
                                    fontSize: '11px',
                                    fontFamily: 'Poppins',
                                    borderRadius: topicFilter === 'red' ? '87px' : '0',
                                    padding: '5px 7px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: topicFilter === 'red' ? "#fff" : "transparent",  //ff6961
                                    color: topicFilter === 'red' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: topicFilter === 'red' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }

                            } >
                            {t("Red")}
                        </ToggleButton>
                        <ToggleButton
                            value="orange"
                            disabled={isLoading === true}
                            aria-label="orange"
                            style={
                                // toggleButtonStyles(isTggleOpen)
                                {
                                    fontSize: '11px',
                                    fontFamily: 'Poppins',
                                    borderRadius: topicFilter === 'orange' ? '87px' : '0',
                                    padding: '5px 7px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: topicFilter === 'orange' ? "#fff" : "transparent",   //ffc57a
                                    color: topicFilter === 'orange' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: topicFilter === 'orange' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }
                            } >
                            {t("Orange")}
                        </ToggleButton>
                        <ToggleButton
                            value="white"
                            disabled={isLoading === true}
                            aria-label="white"
                            style={
                                // toggleButtonStyles(isTggleOpen)
                                {
                                    fontSize: '11px',
                                    fontFamily: 'Poppins',
                                    borderRadius: topicFilter === 'white' ? '87px' : '0',
                                    padding: '5px 7px',
                                    textTransform: 'capitalize',
                                    border: 'none',
                                    backgroundColor: topicFilter === 'white' ? "#fff" : "transparent",
                                    color: topicFilter === 'white' ? "#012248" : "#a0a0a0",
                                    cursor: 'pointer',
                                    boxShadow: topicFilter === 'white' ? '0 2px 2px 0 rgba(0, 0, 0, 0.1)' : '',
                                    transition: 'background-color 0.3s ease, color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.heading.main,
                                        color: theme.palette.drawerBackground.main,
                                        transform: 'scale(1.05)',
                                    },
                                }
                            } >
                            {t("White")}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </div>

            <table
                border="1"
                cellPadding="6"
                style={{ borderCollapse: "collapse", lineHeight: '2.1', textAlign: "center", width: "100%", background: '#fff' }}
            >
                {/* <colgroup>
                    Give Topic column a fixed or % width
                    <col style={{ width: "400px" }} />
                    Remaining columns auto-distribute
                    {allTests.map(() => (
                        <col key={Math.random()} style={{ width: `${100 / allTests.length}%` }} />
                    ))}
                </colgroup> */}
                <thead style={{ background: "#fff", position: "sticky", top: 0, zIndex: 2 }}>
                    <tr>
                        <th
                            style={{
                                width: isMobile ? "115px" : "400px",
                                textAlign: "left",
                                fontFamily: "Poppins",
                                fontWeight: "700",
                                color: "#594e4e",
                                fontSize: isMobile ? "inherit" : "16px",
                            }}
                        >
                            Topic
                        </th>

                        {allTestsInfo &&
                            allTestsInfo.map((test) => (
                                <th
                                    key={test.testId}
                                    style={{
                                        textAlign: "center",
                                        fontFamily: "Poppins",
                                        fontWeight: "700",
                                        color: "#594e4e",
                                        fontSize: isMobile ? "inherit" : "16px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => showEvaluationModel(test.testId, test.testName)} // ✅ send testId & testName
                                >
                                    <div style={{ lineHeight: 1.2 }}>
                                        {formatDate(test.testAttemptedOn)}
                                        <br />
                                        <small>{formatTime(test.testAttemptedOn)}</small>
                                    </div>
                                </th>
                            ))}
                    </tr>
                </thead>

                <tbody style={{ borderWidth: '0.5px', borderColor: '#e3e3e3' }}>
                    {isLoading ? (
                        <tr>
                            <td colSpan={allTests.length + 1} style={{ textAlign: "center", padding: "40px" }}>
                                <CircularProgress
                                    style={{
                                        size: "1rem",
                                        color: "#f8cb1e",
                                        marginInline: "40%",
                                        marginTop: "100px",
                                        marginBottom: "100px",
                                    }}
                                />
                            </td>
                        </tr>
                    ) : (
                        (() => {
                            const filteredTopics =
                                matrixTableData?.filter((topic) => {
                                    const color = getTopicBackground(topic.Tests, allTests.length);
                                    if (topicFilter === "all") return true;
                                    if (topicFilter === "green") return color === "#62ff62";
                                    if (topicFilter === "red") return color === "#ff6961";
                                    if (topicFilter === "orange") return color === "#ffc57a";
                                    if (topicFilter === "white") return color === "white";
                                    return true;
                                }) || [];

                            if (filteredTopics.length === 0) {
                                return (
                                    <tr>
                                        <td colSpan={allTests.length + 1} style={{ textAlign: "center", padding: "20px", color: "gray" }}>
                                            No data found
                                        </td>
                                    </tr>
                                );
                            }

                            return filteredTopics.map((topic) => (
                                <tr key={topic.TopicId}>
                                    <td
                                        style={{
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            color: "#594e4e",
                                            background: getTopicBackground(topic.Tests, allTests.length),
                                        }}
                                    >
                                        {topic.TopicName}
                                    </td>
                                    {allTests?.map((test) => {
                                        const stats = topic.Tests[test];
                                        return (
                                            <td
                                                key={test}
                                                style={{
                                                    background: getCellColor(stats),
                                                    fontFamily: "Poppins",
                                                }}
                                            >
                                                {stats ? (
                                                    <div
                                                        style={{
                                                            display: isMobile ? "block" : "flex",
                                                            justifyContent: "space-evenly",
                                                        }}
                                                    >
                                                        <div style={{ color: "green" }}>{stats.Correct}</div>
                                                        <div style={{ color: "red" }}>{stats.Incorrect}</div>
                                                        <div style={{ color: "gray" }}>{stats.Unattempted}</div>
                                                    </div>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ));
                        })()
                    )}
                </tbody>

            </table>
            {evaluationModel}
        </div >
    );
}

export default TopicPulseTable;

